import React, { useEffect, useContext } from "react";
import { Link } from "react-router-dom";

import { ModeContext } from "../../context/ModeContext";

import { ClearClaims, Logout } from "../../API/Logout";
import "../../css/Header.css";

const Header = () => {
  let currentPage = window.location.pathname;

  const role = localStorage.getItem("role");

  const [currentMode, setCurrentMode] = useContext(ModeContext);

  return (
    <div className="header">
      <nav className="navbar">
        <Link className="navbar-brand" to="/">
          <img src="data:image/png;base64,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" />
        </Link>
        <div
          className="collapse navbar-collapse show"
          id="navbarSupportedContent"
        >
          <ul className="navbar-nav">
            <li
              className={
                "nav-item " + (currentPage === "/home" ? "active" : "")
              }
            >
              <Link className="nav-link" to="/home">
                Shelf Marking
              </Link>
            </li>
            <li
              className={
                "nav-item " + (currentPage === "/bbox" ? "active" : "")
              }
            >
              <Link className="nav-link" to="/bbox">
                Bbox
              </Link>
            </li>
            <li
              className={
                "nav-item " +
                (currentPage === "/labelVerification" ? "active" : "")
              }
            >
              <Link className="nav-link" to="/labelVerification">
                Label Verification
              </Link>
            </li>
            <li
              className={
                "nav-item " + (currentPage === "/pricingQA" ? "active" : "")
              }
            >
              <Link className="nav-link" to="/pricingQA">
                Pricing QA
              </Link>
            </li>
            <li
              className={
                "nav-item " + (currentPage === "/auditReview" ? "active" : "")
              }
            >
              <Link className="nav-link" to="/auditReview">
                Audit Review
              </Link>
            </li>
            <li
              className={
                "nav-item " + (currentPage === "/viewOneImage" ? "active" : "")
              }
            >
              <Link className="nav-link" to="/viewOneImage">
                View One Image
              </Link>
            </li>
          </ul>
          <div className="dropdown float-right">
            <button
              className="btn btn-secondary"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              onClick={() => {
                ClearClaims();
                Logout();
              }}
            >
              Logout
            </button>
            {role === "expert" && (
              <div className="mode-switch">
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={currentMode === "expert"}
                    onChange={() => {
                      if (currentMode === "expert") {
                        setCurrentMode("ordinary");
                        localStorage.setItem("mode", "ordinary");
                      } else {
                        setCurrentMode("expert");
                        localStorage.setItem("mode", "expert");
                      }
                    }}
                  />
                  <span className="slider round"></span>
                </label>
                <p>Expert Mode</p>
              </div>
            )}
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Header;
